/**
 * La mascotte : une chouette messagère, casque ailé et tasse à la main.
 *
 * Elle n'apparaît qu'à deux endroits, et jamais ailleurs : l'écran de
 * connexion, et l'état vide de la bibliothèque. Une mascotte qui suit
 * l'utilisateur d'écran en écran devient du bruit au bout de la troisième
 * recherche de la journée.
 *
 * La respiration et les volutes sont les seules animations en boucle de tout
 * le produit. Elles sont admises ici parce qu'on n'y fait rien d'autre
 * qu'attendre — et `prefers-reduced-motion` les coupe toutes les deux.
 */

interface OwlProps {
  /** Sans la vapeur : pour les usages décoratifs plus petits. */
  quiet?: boolean;
}

export function Owl({ quiet = false }: OwlProps) {
  return (
    <div className="owl" aria-hidden="true">
      <div className="owl-shadow" />
      <div className="owl-tilt">
        <div className="owl-breathe">
          <img
            className="owl-img"
            src="/hermes/mascotte.png"
            alt=""
            width={196}
            height={209}
            /* Premier pixel de l'écran de connexion : elle ne doit pas
               arriver après le formulaire. */
            fetchPriority="high"
            decoding="async"
          />

          {/* Les volutes sont calées sur ce dessin précis — la tasse est tenue
              à gauche, à peu près au tiers de la hauteur. Changer l'image
              oblige à refaire ce calage. */}
          {quiet ? null : (
            <svg
              className="owl-steam"
              width="70"
              height="90"
              viewBox="0 0 70 90"
              fill="none"
              stroke="#8a6a4a"
              strokeWidth="4"
              strokeLinecap="round"
            >
              <path d="M35 88 C 30 79 39 71 34 62 C 31 56 36 52 34 48" />
              <path d="M35 88 C 41 80 32 72 37 64 C 41 58 35 54 38 50" />
              <path d="M35 88 C 33 78 42 70 36 62 C 32 56 38 52 35 47" />
            </svg>
          )}
        </div>
      </div>
    </div>
  );
}
